import {toPng} from 'html-to-image';

export async function capturePageScreenshot(): Promise<File> {
  await new Promise<void>(resolve => setTimeout(resolve, 200));

  const dataUrl = await toPng(document.body, {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: window.devicePixelRatio || 1,
    // Skip cross-origin images (Auth0 avatar, firm logos, CDN assets)
    filter: el => {
      if (el instanceof HTMLImageElement && el.src) {
        try {
          return new URL(el.src).origin === window.location.origin;
        } catch {
          return true;
        }
      }
      return true;
    }
  });

  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], `screenshot-${Date.now()}.png`, {type: 'image/png'});
}
